import axiosInstance from "../../../../shared/api/axiosInstance.js";
import { baseUrl, DELETE_COUNTRY, EDIT_COUNTRY, CREATE_COUNTRY } from "../../../../shared/api/endpoints.js";
import { configReq } from "../../../../shared/lib/functions.js";
/** Keeps the existing DELETE request and response contract. */
export function deleteCountry(data, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_COUNTRY}?id=${data.id}`, configReq(token));
}

/** Keeps the existing PUT request and response contract. */
export function editCountry(formData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_COUNTRY}`, formData, configReq(token, true));
}

/** Keeps the existing POST request and response contract. */
export function createCountry(formData, token) {
  return axiosInstance.post(`${baseUrl}/${CREATE_COUNTRY}`, formData, configReq(token));
}
